import { Block, CenterFocusStrong } from "@material-ui/icons";
import TableStyles from "../../styles/TableStyles.css";
import CommonStyles from "../../styles/CommonStyles.css";

export const styles = (theme) => ({
  ...TableStyles,
  ...CommonStyles,
  square: {
    width: "100px !important",
    display: "flex",
    borderRadius: "3px",
    alignItems: "center",
  },
  MuiError:{
    "& .MuiSelect-select":{
      background:" #9C214E!important",
      borderColor: "#9C214E!important",
    },
    "& input":{
      background:" #9C214E!important",
      borderColor: "#9C214E!important",
    },
    "& textarea":{
      background:" #9C214E!important",
    }
  },
  clearMe: {
    fontSize: "11px",
    borderRadius: "3px",
    background: "#DBBF63",
    color: "#000",
    verticalAlign: "middle",
    padding: "4px 9px",
    position:"relative",
    textTransform:"uppercase",
    fontWeight:"normal"
  },
  clearanceCheckBoxFormRight:{
    fontSize:"0.8em",
    marginBottom:"15px",
    margin: "0",
    display: "block",
    borderBottom: "1px solid #7a7a7a",
    paddingBottom: "10px",
    "& .MuiFormControlLabel-label":{
      fontSize:"1em",
    },
  },
  historyQuestions:{
    padding:"10px 20px",
    background:"#2a2a2a",
    borderRadius: "5px",
    margin: "10px 0",
  }, 
  noteItem:{
    color:"#ff9a9a",
    fontWeight:"bold",
  }, 
  muDetailWrapCF:{
    display: "block",
    padding: "8px 0",
    borderBottom: "1px solid #5a5a5a",
    fontSize: "13px",
    "& .clLabel":{
      marginBottom:"5px",
    }
  },
  boldLabel:{
    fontWeight:"bold",
    fontSize:"0.85em",
    padding: "14px 15px",
    background: "#323232",
    margin:"10px 0",
    border: "1px solid #5a5a5a",
    fontSize:"13px",
    borderRadius: "4px",
    "& .clLabel":{
      marginBottom:"5px",
  
    },
    "& .clContents":{
      marginBottom:"10px",
      // paddingLeft:"10px",
    },
    "& .clContents > div":{
      color:"#ff9a9a",
      margin: "4px 0",
      display: "block",
    }
  },
  appBar: {
    position: "relative",
    backgroundColor:"#474747 !important",
  },
  appbarStyles:{
    position: "relative",
    backgroundColor:"#474747  !important",
    display:"flex",
    borderBottom:"1px solid #71716f",
    justifyContent: "flex-start",
  },
  appbarEditStyles:{
    backgroundColor:"#212121  !important",
    height: "calc(100vh - 66px)",
    overflowY:"auto",
    overflowX: "hidden",
    paddingBottom:"15px",
    "& input": {
      borderRadius: "4px !important",
      padding: "8.5px 27px 8.5px 8.5px",
       fontSize:"0.8em",
      background:"#575757",
    }
  },

  clearanceButtonSet:{
    paddingRight:"31px",
    paddingBottom:"35px",
    paddingLeft:"40px",
  },
newOptionItem:{
    border:"1px solid #725a1a",
    borderRadius:"5px",
    padding:"5px 10px",
    marginRight:"15px",
  },
 
clearanceSearchArea: {
    boxSizing:"border-box",
    alignItems: "start",
    position:"relative",
    zIndex:"99", 
    marginBottom: "0px",
    marginRight: "auto",
    marginTop: "13px",
    "& .MuiListItem-button:hover": {
      background: "#424242",
    },
    "& .MuiListItem-button .active": {
      background: "#424242",
    },
    "& .MuiChip-outlined": {
      border: " 1px solid rgb(255 200 0)",
      fontSize: "0.75em",
      backgroundColor: "transparent",
      height: "30px",
      "& .MuiChip-label": {
        color: "rgb(255 200 0)",
      },
    },
    "& .dropdown-menu": {
      background: "#383838",
      color: "#fff",
      "& a":{
        color:"#fff",
        padding:"10px",
        display: "block",
        borderBottom:"1px solid #535353",
        fontSize: "12px",
      }
    },
    "& .dropdown-menu a.disabled": {
      background: "#383838",
      padding: "10px",
      fontSize: "0.75em",
      display: "block",
      color: "#ffcb0e",
      border: " 1px solid #6d6a6a",
      borderTop: "none",
      borderRadius: "0px 0px 3px 3px",
    },
    "& .MuiChip-root": {
      fontSize: "0.75em",
      marginRight: "5px",
      marginBottom: "5px",
    },
    "&  input": {
      padding: "10px",
      background: "#5a5a5a",
      borderRadius: "3px",
      height:"inherit",
      minWidth:"500px",
      color: "#fff",
      border: "1px solid rgba(255, 255, 255, 0.23)",
      fontSize: "12px",
      width: "100%",
      boxSizing: "border-box",
    },
    "& input:focus": {
      borderColor: "#46af22 !important",
      outline: "none",
    },
    "& input:hover": {
      borderColor: "#46af22 !important",
    },
    "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline":{
      borderColor:"#46af22 !important",
    }
  }, 
  clearanceSearchAreaRemoveMargin:{
    marginTop:"0 !important",
  },
newOptionWrapper:{
    backgroundColor:"#005371 !important",
    display: "flex",
    padding:"20px 32px 0px 32px",
    "& input": {
      borderRadius: "5px !important",
      padding: "8.5px 27px 8.5px 8.5px",
       fontSize:"0.8em",
      background:"#725a1a",
    },
    "& h2":{
      margin:"0",
      padding:"5px 0 0px 0",
      fontSize: "13px",
    },
    "& span":{
      margin:"0",
      padding:"5px 0",
      display:"block",
      fontSize: "13px",
    },
    "& .dropdown-item span":{
      display:"inline !important",
      alignItems: "baseline"
    }
  },
  noPaddindMargin:{
    padding: "20px 0px",
    borderBottom: "1px solid #555",
    width:"100%",
    marginBottom:"10px",
    "& h3":{
      margin:"0",
      padding:"10px 0",
      fontSize: "14px",
    },
    "& .MuiTypography-root":{
      fontSize: "14px",
      paddingLeft:"5px",
    }
  },
  mainQuestions:{
    width:"auto !important",
    padding: "0 !important",
    "& .MuiFormControlLabel-root":{
      color:"#fff",
    },
    "& .MuiFormGroup-root":{
      flexDirection:"row",
      "& > span":{
        margin:"0 10px 0 0",
        borderRadius:"5px",
      }
     
    }
   
  },

  colorThemeOne:{
    // background:"#16A168",
    background:"#5b5b5b",
    cursor:"pointer",
    color:"#fff",
    "&:hover":{
      background:"#16a168",
    },
    "& .MuiRadio-colorSecondary.Mui-checked":{
      color:" #fff !important",
    },
    "& label":{
      padding:"10px 20px",
    },
    "& .MuiFormControlLabel-root":{
      padding:"10px 20px",
    },
  },
  colorThemeTwo:{
    // background:"#2a769b",
    background:"#5b5b5b",
    color:"#fff",
    cursor:"pointer",
    "&:hover":{
      // background:"#1d678b",
      background:"#16a168",
    },
    "& .MuiRadio-colorSecondary.Mui-checked":{
      color:" #fff !important",
    },
    "& label":{
      padding:"10px 20px",
    },
    "& .MuiFormControlLabel-root":{
      padding:"10px 20px",
    },
  },
  colorThemeThree:{
    // background:"#16A168",
    cursor:"pointer",
    background:"#5b5b5b",
    color:"#fff",
    "&:hover":{
      background:"#16a168",
    },
    "& .MuiRadio-colorSecondary.Mui-checked":{
      color:" #fff !important",
    },
    "& label":{
      padding:"10px 20px",
    },
    "& .MuiFormControlLabel-root":{
      padding:"10px 20px",
    },
  },


  newQuestionsBlock:{
    padding:"30px 30px 0px 30px",
    "& label":{
      fontSize:"13px",
      lineHeight: "20px",
      margin:"0 0 5px 0",
      fontSize: "14px",
      fontWeight:"bold",
    display: "inline-block",
    "& img":{
      display: "inline-block",
      maxWidth: "38px !important",
      verticalAlign:"middle",
      marginRight:" 10px",
    }
    },
    "& .MuiFormGroup-root label":{
      margin:"0",
    },
    "& .MuiFormControlLabel-label":{
      fontSize:"13px",
      fontWeight:"bold",
      "& label":{
        fontWeight:"bold",
      }
    },
    "& .MuiSelect-select":{
      padding:"8px 10px",
      background:"#575757",
    }
  },

  formErrorRadio:{
    "& .MuiRadio-root":{
      color:"#9C214E!important",
    }

  },
  questionGroup:{
    display:"flex",
    padding: "10px 0",
    alignItems:"center",
    borderRadius:"5px",
    "& .MuiInputBase-input":{
      borderColor: "rgba(255, 255, 255, 0.23)  !important",
      background: "#505050",
      fontSize:"13px",
      border:"1px solid",
      padding:"10px 10px 8px 10px",
      borderRadius:"5px",
      "&:hover":{
        borderColor: "#46af22 !important",
      },
    },
    "& .Mui-error": {
      fontSize:"12px",
      "& .MuiSvgIcon-root":{
        color:"#fff",
      },
      "& .MuiInputBase-input": {
        background: "#9C214E!important",
      }
    },
    "& .MuiAutocomplete-hasPopupIcon":{
      "& .MuiOutlinedInput-input":{
        borderColor:"transparent  !important",
        paddingLeft:"10px !important",
      },
      "& .MuiAutocomplete-inputRoot":{
        background:" #505050",
      },
      "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":{
        borderColor:"#46af22  !important"
      },
      "& .MuiInputBase-input:hover":{
        borderColor:"transparent  !important"
      },
      "&.MuiInputBase-input:hover":{
        borderColor:"#46af22  !important"
      },
    },
    "& span.Mui-error":{
      width:"100%",
      paddingTop:"5px",
      display:"block",
    },
    "& .MuiFormGroup-root":{
      flexDirection: "row",
      alignItems: "center",
      "& label":{
        marginRight:"15px",
      }
    },
    "& .MuiTextField-root":{
      "& input":{
        padding:"9px",
        border:"1px solid rgba(255, 255, 255, 0.23) !important",
      },
      "& .Mui-focused":{
        borderColor:"#46af22 !important",
      }
    },
    "& div":{
      width:"100%",
      "&.rbt-aux":{
        width:"auto",
      },
      
      "&.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline":{
        borderColor: "#46af22"
      },
      "& .MuiOutlinedInput-input": {
        padding: "10px",
        fontSize: "13px",
        background: "#505050",
        fontWeight: "400!important",
        height:"inherit"
    },
      "& .Mui-error": {
        "& .MuiInputBase-input": {
          background: "#9C214E!important",
        }
      },
    "& .MuiInputBase-adornedEnd":{
      padding:"0 !important",
      background:"#505050",
      "& input":{
        border:"none",
      },
      "& div":{
        width:"auto",
        "& .MuiSvgIcon-root":{
          fontSize:"1.5rem",
          color:"#fff"
        }
      }
    },
    },
    "& .MuiAutocomplete-popupIndicator":{
      marginRight: "-5px"
    }
  },
  durationPicker:{
    margin:"0 0px 0 -2px",
    display:"flex",
    "& label":{
      padding: "0",
      fontSize: "13px",
      fontWeight: "normal",
      color: "rgba(255, 255, 255, 0.7)",
      flexBasis: "50%",
      flexGrow: "0",
      "& input":{
        padding:"11px 13px 11px 6px !important",
        background: "#505050",
        borderRadius:" 3px",
        border: "1px solid",
      },
      "& .MuiFormControl-root":{
        width:"100%",
      }
    },
    "& .MuiFormControl-root":{
      "& .MuiInput-underline:before":{
        borderColor:"rgba(255, 255, 255, 0.23)",
        borderRadius: "5px",
      },
      "& .MuiInput-underline:after":{
        borderColor:"#46af22",
        borderRadius: "5px",
      }
    },
  },
  tableFilterDate: {
    marginTop: "0",
    marginBottom: "0",
    "& input": {
      padding: "10px 10px 8px 8px !important",
    },
    "& .MuiInput-underline:after": {
      display: "none",
    },
    "& .MuiInput-underline:before": {
      display: "none",
    },
    "& .MuiInput-underline": {
      border: "1px solid rgb(76 76 76) !important",
      background: "transparent !important",
      "& button": {
        borderRadius: "5px",
      },
      "& .MuiButton-root": {
        width: "30px",
        height: "30px",
      },
      "& .MuiIconButton-root": {
        width: "30px",
        height: "30px",
      },
      "&:hover": {
        borderColor: "#46af22",
      },
      "&:focus": {
        borderColor: "#46af22",
      }
    },
    "& .Mui-focused": {
      borderColor: "#46af22",
    },
    "& .MuiInputAdornment-root": {
      width: "auto",
      marginRight: "3px",
      "& svg": {
        width: "18px",
      }
    },
    "& .Mui-disabled .MuiInputAdornment-root": {
      marginRight: "28px",
    },
  },
  dateDropdownPicker:{
    display:"flex",
    margin:"0 -5px",
    "& .MuiFormControl-root":{
      padding: "0 5px",
      "& .MuiInput-underline:before":{
        borderColor:"rgba(255, 255, 255, 0.23)",
        borderRadius: "5px",
      },
      "& .MuiInput-underline:after":{
        borderColor:"#46af22",
        borderRadius: "5px",
      }
    },
    "& .MuiSelect-select":{
      borderRadius:"5px",
      fontSize:"13px"
    }
  },
  durationDropdownPicker:{
    "& input":{
      borderRadius: "5px !important",
      padding: "8.5px 27px 8.5px 8.5px",
       fontSize:"0.8em",
      background:"#353535 !important",
      borderColor:"rgba(255, 255, 255, 0.23) !important"
    } 
  },
  textLeftChar:{
    textAlign:"left",
    "& span":{
      textAlign:"left",
    }
  },
  batchClearanceInput: {
    width:"100%",
    "& p.Mui-error":{
      margin:"5px 0 0px 0",
      pointerEvents: "none",
    },
    "& .MuiInputBase-formControl":{
      "& input":{
        minWidth:"inherit"
      },
    },
    "& input": {
      borderRadius: "5px !important",
      padding: "8.5px 27px 8.5px 8.5px",
      fontSize:"12px",
      background:"#353535",
      minWidth:"350px",
    },
    "& div": {
      borderRadius: "5px !important",
      width:"100%",
      margin:"0 !important",
      justifyContent: "flex-start",
    },
    "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline":{
      borderColor: "#46af22 !important",
    }
  },
 clearanceInput: {
    width:"100%",
    "& p.Mui-error":{
      margin:"5px 0 0px 0",
      pointerEvents: "none",
    },
    "& .MuiInputBase-formControl":{
      "& input":{
        minWidth:"280px"
      },
    },
    "& input": {
      borderRadius: "5px !important",
      padding: "8.5px 27px 8.5px 8.5px",
      fontSize:"12px",
      background:"#353535",
      minWidth:"350px",
    },
    "& div": {
      borderRadius: "5px !important",
      width:"100%",
      margin:"0 !important",
      justifyContent: "flex-start",
    },
    "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline":{
      borderColor: "#46af22 !important",
    }
  },
  appbarTitleStyles:{
     width:"-webkit-fill-available",
     width:"100%",
     padding:"10px",
  },
  appbarButtonStyles:{
    display:"flex",
    padding:"8px 10px 8px 5px",
 },

 appbarTitle:{
   display:"flex",
   alignItems: "baseline",
   maxWidth: "650px",
// Added Breakpoints
[theme.breakpoints.down("sm")]: {
  maxWidth: "600px",
},
[theme.breakpoints.up("md")]: {
  maxWidth: "490px",
},
[theme.breakpoints.up("lg")]: {
  maxWidth: "650px",
},


   "& button":{
      background:"none",
      "&:hover":{
        background:"none",
      }
   },
   "& h2":{
    margin: "0",
    position:"relative",
    fontSize: "21px",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
   }
 },

 clearanceOkButton: {
  background: "#0C853E !important",
  boxShadow: "none",
  float:"right",
  color: "#fff",
  border:"1px solid #0C853E !important",
  textTransform: "none",
  fontWeight: "400",
  margin: "0px 0px 0px 10px",
  padding:"5px 15px",
  fontSize:"0.8em",
  minWidth:"inherit !important",
  "&:hover": {
      background: "#000 !important",
      color: "#29D211 !important",
      border:"1px solid #403f3f !important",
  },
  "& .MuiCircularProgress-colorPrimary":{
    width: "13px !important",
    height: "13px !important",
    color: "#fff !important",
    marginLeft: "5px !important",
  },
},
  clearanceWizardTitle: {

    flex: 1,
    fontSize: "18px",
    fontWeight: "500",
  },
  clearanceWizardCloseButton:{
    borderRadius:"5px !important",
    marginLeft:"2px",
    background:" #242424",
    border: "1px solid #242424",
    padding: "6px !important",
    width:"32px",
    "& svg":{
      fontSize:"16px",
    },
    "&.Mui-focusVisible":{
      background:"#606060",
    }
  },
  clearanceWizardToolBar:{
    minHeight: "50px",
    background: "#010101",
  },
  form: {
    padding: "12px",
  },
  progress: {
    padding: "12px",
  },
  selectBox:{

  },
  modelBody:{
    backgroundColor:"#000",
    "& .MuiPaper-root":{
    backgroundColor:"#000",
    },
    "& .MuiSelect-select":{
      padding:"8px",
  
    }
  },
  saveButton:{
    backgroundColor:"#0C853E",
    "&:hover":{
      backgroundColor:"#000",
      color:"#0C853E",
    }
  },
  nextButton:{
    backgroundColor:"#4e4e4e",
    border:" transparent 1px solid",
    margin:"15px 15px",
    "&:hover":{
      border:" #0C853E 1px solid",
      backgroundColor: "#000",
    }
  },
  rules : {
    padding: "12px",
    backgroundColor: "green",
    fontSize: "15px"
  },
  trackDData:{
  
    background: "#4e4e4e",
    padding: "10px",
    borderRadius: "3px",
    marginTop: "15px",
    alignItems: "center",
    margin: "15px",
    "& .MuiAvatar-root":{
      marginRight: "12px",
    }
  },
  clearanceHeaderWrapper:{
    padding: "15px 20px 30px 20px",
    borderRadius: "4px", 
    "& span":{
      fontSize: "11px",
      display:"block",
    }
  },
  clearanceHeaderMoreIcon:{
    width:"32px",
    height:"32px",
    minWidth:"inherit",
    color:"#000",
    "& span":{
      margin:"0 !important",
    },
    "& svg":{
      fontSize:"16px",
    }
  },

  clearanceHeaderDetails:{
    display:"flex",
    fontSize:"1em",
    alignItems:"center",
    minHeight: "60px",
    justifyContent: "flex-end",
    "& span":{
      marginLeft: "15px",
      fontSize:"18px",
      lineHeight: "1px",
    }
  },

  
  clearanceTrackHeaderDetails:{
    display:"flex",
    fontSize:"22px",
    alignItems:"center",
    minHeight: "60px",
    justifyContent: "flex-end",
    "& span":{
      marginLeft: "15px",
      fontSize:"18px",
      lineHeight: "1px",
    },
  },
  clearanceTrackDetailsIcon:{
    color:"#15A24F",
    width:"34px",
    height:"32px",
    minWidth:"inherit",
    "& span":{
      margin:"0",
    }
  },
  clearanceHeaderIcon:{
    color:"#000",
    width:"34px",
    height:"32px",
    minWidth:"inherit",
    "& span":{
      margin:"0",
    }
  },
  clearanceTrackDetailsMoreIcon:{
    width:"32px",
    height:"32px",
    minWidth:"inherit",
    color:"#fff",
    "& span":{
      margin:"0 !important",
    },
    "& svg":{
      fontSize:"16px",
    }
  },
  singleTrackData:{   
    background: "#2d2d2d",
    padding: "10px",
    borderRadius: "3px",
    marginTop: "15px",
    alignItems: "center",
    margin: "15px 0",
    "& .MuiAvatar-root":{
      marginRight: "12px",
    }
  },
  singleTrackstatus:{
    color: "#fff",
    fontSize:"1em",
    float:"left",
    marginTop: "5px",
    "& div":{
      padding: "5px 9px",
      borderRadius: "4px",
      margin:"0 0 5px 0",
      color: "#000",
    },
  },
  clearanceAcordianContainer:{
    background:"#000",
    "& .MuiGrid-spacing-xs-3 > .MuiGrid-item":{
      padding:"0px 12px !important",
    },
    "& .Mui-expanded":{
      fontWeight: "500",
      color:"#fff",
      "& span":{
        display:"block",
        fontWeight: "400",
        marginBottom:"5px",
        overflow: "hidden",
        textOverflow:"ellipsis",
      },
      "& button":{
        color:"#fff",
      },
      "& div":{
        color:"#fff !important",
      }
    },
    "& .MuiCollapse-entered":{
      color:"#fff",
     
    },
    "& .MuiAccordionSummary-root":{
      background:"#37557D",
    },
    "& .MuiAccordionDetails-root":{
      padding:"0",
      display: "block",
    }
  },
  
  clearanceWizardHeaderQuiz:{
    color:"#fff",
    background: "#005371",
    padding: "20px",
    borderBottom:" 1px solid rgba(117,117,117,0.5)",    
    fontWeight: "500",
    "& .MuiSelect-outlined.MuiSelect-outlined": {
      paddingRight:" 32px",
      background: "#005371",
      paddingTop: "9px",
      paddingBottom: "10px",
      textAlign:"left", 
      minWidth:"100px",
      maxWidth:"100px",
      height:"inherit",
      minHeight:"inherit",
      "& option":{
        padding:"10px",
      }
     
  },
  "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline":{
    borderColor: "#46af22 !important",
  },
  "& h2":{
    fontSize:"17px",
    display: "inline-block",
    verticalAlign: "super",
    marginTop:"25px",
    color:"#00DCFF",
    paddingLeft:"0"
  },
  "& .MuiCircularProgress-colorPrimary": {
    color: "#ffffff",
    width: "15px !important",
    height: "15px !important",
    marginLeft: "5px",
  },
  },
  clearanceWizardLoading:{
    "& .MuiCircularProgress-colorPrimary": {
        color: "#ffffff",
        width: "15px !important",
        height: "15px !important",
        marginRight: "10px",
    },
    padding:"20px 75px",
    display: "block",
    minHeight: "30px",
    alignItems: "center",
    display: "flex",
    justifyContent: "flex-start",
     fontSize:"1em",
    fontWeight: "400",
},

clearanceWizardReport:{
  "& .MuiCircularProgress-colorPrimary": {
    color: "#ffffff",
    width: "15px !important",
    height: "15px !important",
    marginRight: "10px",
},
color: "#b4d5f5",
  padding:"30px 20px 10px 20px",
  display: "block",
  minHeight: "30px",
  alignItems: "center",
  display: "flex",
  justifyContent: "center",
   fontSize:"1em",
  fontWeight: "400",
},
  runClearanceButtonWrap:{
    textAlign:"left",
    marginBottom:"20px",
    "& button":{
      margin:"0px 0px 0px 10px",
      fontSize:"12px",
    }
  },
  clearanceStatusValue:{
    marginTop:"0",
    fontWeight: "400",
    padding: "0",
    color:"#fff",
    "& path":{
      stroke:"#cac184"
    }
  },
  clearanceNotesInsert:{
    textAlign:"left",
    paddingLeft:"0",
 // Added Breakpoints
  [theme.breakpoints.down("sm")]: {
    margin:"0px",
  },
  [theme.breakpoints.up("md")]: {
    margin:"0px ",
  },
  [theme.breakpoints.up("lg")]: {
    margin:"0px",
  },
  },
  clearanceStatus:{
    fontWeight: "400",
    fontSize: "12px",
    maxWidth:"350px",
    margin: "10px 0 10px 10px",
    borderRadius: "3px",
    minWidth:"150px",
    padding: "10px 0 10px 5px",
    wordBreak: "break-word",
    "& span":{
      color:"#d8c7b6 !important",
      textTransform:"uppercase",

    },

  },
  quizRemovePadding:{
    padding:"0px 10px 15px 12px!important",
    "& span":{
      color:"#fff",
    }
  },
  clearanceSign: {
    minWidth: "20px",
    height: "20px",
    borderRadius: "50%",
    margin: "5px 10px 5px 0px",
    display: "inline-block",
    verticalAlign: "middle",
  },
  clearanceStatus2:{
    fontWeight: "400",
    fontSize: "12px",
    margin: "0px 5px",
    borderRadius: "3px",
    padding: "0 10px",
    wordBreak: "break-word",
    width:"-webkit-fill-available",
    width:"100%",
    "& span":{
      color:"#fff",
      display:"block",
      textAlign: "left",
    fontSize: "11px",
    wordBreak: "break-word",
    },
    "& svg":{
      fontSize: "24px",
      display: "block",
      margin: "0 10px 0 0",
      minWidth:"20px",
    },
  },

  clearanceStatusMessages:{
    display:"flex",
    marginLeft:"25px",
    textAlign:"left",
    justifyContent: "flex-start",

    "& > div":{
      maxWidth:"inherit",
      fontSize: "1em",
      lineHeight: "19px",
    },
      // Added Breakpoints
      [theme.breakpoints.down("sm")]: {
        margin:"0px",
      },
      [theme.breakpoints.up("md")]: {
        margin:"0px",
      },
      [theme.breakpoints.up("lg")]: {
        margin:"0px",     
      },
  },
  clearanceWizardTrackQuiz:{
    color:"#00DCFF",
    padding: "20px 20px 35px 20px",
    boxShadow: "none",
    fontWeight: "500",
    fontSize:"14px",
    "& h2":{
      color:"#fff",
      fontSize:"17px",
      display: "inline-block",
    verticalAlign: "super",
    }
  },
  clearanceWizardNotes:{
    width:"100%",
    margin:"0",
    background:"#505050",
    border: "1px solid #707070",
    padding: "10px",
    borderRadius: "3px",
    boxSizing: "border-box",
    minHeight: "50px",
    color:"#fff",
    fontFamily: "Arial",
    outline: "none",
    "&:hover":{
      border:"1px solid #46af22",
    },
    "&:focus":{
      border:"1px solid #46af22",
    },
 
  },
 
  clearanceHelp:{
  marginLeft: "6px",
  verticalAlign:"middle",
  fontSize: "19px",

},
clearanceHelpQuest:{
  "& svg":{
    color: "#ff6f6f",
      margin: "0 8px",
      fontSize: "1.5em",
      verticalAlign: "bottom",
  }
},
clearanceInfo:{
  marginLeft: "10px",
  verticalAlign: "text-bottom",
  fontSize: "19px",
  color:"#000",
},
clearanceStatsusWrapper:{
  textAlign:"right",
  display:"block",
},
clearancePreviewStatus:{
  display:"flex",
  "& div":{
    paddingTop:"0",
    width:"200px",
  },
  "& label":{
    fontSize:"14px !important",
  }
},
clearanceWizardClearanceName:{
    whiteSpace: "nowrap",
    color:"#fff",
},
clearanceWizardTrackNotes:{
  fontSize:"1em",
},
clearanceWizardTrackNotesEmpty:{
  color:"gray"
},
clearanceWizardNotesContainer:{
  display:"flex", 
  justifyContent:" flex-end",
    paddingTop: "0",
    "& div":{
      marginRight:"20px",
      padding: "0",
    width: "210px",
    },
  "& label":{
    display: "block",
    fontWeight: "600",
     fontSize:"1em",
    marginBottom: "8px",
  },
},
clearanceWizardButtons:{
    margin:"10px 0 20px 0",
    "& button":{
      marginRight:"0 !important",
    }
  },
  clearanceWizardAddNotes:{
    minWidth:"inherit",
    width:"32px",
    height:"32px",
    marginLeft:"10px",
    color: "#000",
  },
  clearanceWizardHeaderQuizItems: {
    color:"#fff",
    fontSize:"14px",
    "& input": {
      visibility: "unset",
    },
    "& .MuiRadio-colorSecondary.Mui-checked": {
      color: "#fff",
    },
    "& .MuiGrid-container:hover":{
      // color: "#fff",
    },
    "& .MuiRadio-root": {
      color: "#fff",
    },
 
    "& hr": {
      background: "rgba(97,97,97,0.8)",
    },
    "& .MuiGrid-container .MuiGrid-item": {
      padding: "2px 0px 2px 0px",
    },
  },
  clearanceWizardTrackStatus:{
    color:"#fff",
    textAlign: "right",
  },
  clearanceWizardSingleTrackStatus:{
    marginLeft:"5px",
  },
  batchClearanceWizardTrackQuizItems:{
    margin:"5px 0",
    "& div":{
      alignItems:"center",
      width:"100%",
      },
    "& .MuiRadio-colorSecondary.Mui-checked": {
      color: "#00DCFF",
  },
  "& .MuiGrid-container:hover":{
    // color: "#fff",
  },
  "& .MuiRadio-root": {
    color: "#00DCFF",
  },
  "& hr":{
    background: "rgba(97,97,97,0.8)",
  },
  "& .MuiGrid-container .MuiGrid-item":{
    // borderBottom:"1px solid  rgba(97,97,97,0.2)",
    padding:"5px 10px 0px 0px",
  },
  },
  clearanceWizardTrackQuizItems : { 
    margin:"5px 0",
    "& div":{
      alignItems:"center",
      width:"100%",
      },
    "& .MuiRadio-colorSecondary.Mui-checked": {
      color: "#00DCFF",
  },
  "& .MuiGrid-container:hover":{
    // color: "#fff",
  },
  "& .MuiRadio-root": {
    color: "#00DCFF",
  },
  "& hr":{
    background: "rgba(97,97,97,0.8)",
  },
  "& .MuiGrid-container .MuiGrid-item":{
    // borderBottom:"1px solid  rgba(97,97,97,0.2)",
    padding:"5px 0px 0px 0px",
  },
  },
  clearanceWizardAnswered:{
    float: "right",
    marginBottom:"0px",
    width:"100%",
    "& .MuiFormControlLabel-root":{
      marginLeft: "-3px",
      marginRight: "20px",
    },
    "& .MuiTypography-body1":{
      fontSize:"14px",
      fontWeight:"bold",
    },   
    "& .MuiSelect-outlined.MuiSelect-outlined": {
      paddingRight:" 32px",
      background: "#005371",
      paddingTop: "9px",
      paddingBottom: "10px",
      textAlign:"left", 
      minWidth: "100px",
      height:"inherit",
      minHeight:"inherit",
      "& option":{
        padding:"10px",
      }
  },
  "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline":{
    borderColor:"#46af22",
  },
  },
  clearanceWizardnotAns:{
    float: "right",
    color: "#fff",
    // marginBottom:"10px",
    width:"100%",
    "& .MuiSelect-outlined.MuiSelect-outlined": {
      paddingRight:" 32px",
      background: "#5d5c5c",
      paddingTop: "9px",
      paddingBottom: "8px",
      textAlign:"left",
      minWidth: "100px",
      minHeight:" inherit",
      height: "inherit",
      "& option":{
        padding:"10px",
      },
  },
  "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline":{
    borderColor: "#46af22 !important",
  },
  "& .MuiIconButton-label":{
      color:"#ffffff",
  },
    "& .MuiFormControlLabel-root":{
      marginLeft: "-3px",
      marginRight: "20px",
    },
    "& .MuiTypography-body1":{
      fontSize:"14px"
    },   
  },
  newInputBlock:{
    padding:"30px 30px 0px 30px",
    "& label":{
      fontSize:"13px",
      lineHeight: "20px",
      margin:"0 0 5px 0",
      fontSize: "14px",
      fontWeight:"bold",
    display: "inline-block",
    "& img":{
      display: "inline-block",
      maxWidth: "38px !important",
      verticalAlign:"middle",
      marginRight:" 10px",
    }
    },
    "& .MuiFormGroup-root label":{
      margin:"0",
    },
    "& .MuiFormControlLabel-label":{
      fontSize:"13px",
      fontWeight:"bold",
      "& label":{
        fontWeight:"bold",
      }
    },
    "& .MuiSelect-select":{
      padding:"8px 10px",
      background:"#575757",
    }
  },
  questionLabels:{
    display:"flex",
    minWidth:"500px",
    alignItems:"center",
    maxWidth:"500px",
    "& label":{
      margin:"0",
      paddingLeft:"10px",
    },
    "& span":{
      margin:"0 5px",
    },
    "& h6":{
      paddingLeft: "10px",
      fontWeight: "bold",
      color: "#ffefb0",
      fontSize: "14px"
    },
    "& .requiredField span":{
      margin:" 0 !important",
    }
  },
  clearanceWizardTextAnswer:{
    display: "table",
    minHeight:"36px",
    textAlign: "left",
    width: "100%",
    "& div":{
      display: "table-cell",
      verticalAlign: "middle",
    },
    "& span":{
      display: "table-cell",
      verticalAlign:"middle",
      // paddingLeft:"10px",
      wordBreak: "break-word",
    wordWrap: "break-word !important",

    }
  },
  checkBoxYesNo:{
    "& span":{
      paddingLeft: "0px !important",
      marginLeft: "-2px",
    },
    "& .Mui-checked":{
      marginLeft: "-1px",
    }
 
  },
  clearanceWizardQuesRow:{
    display:"table",  
    // padding:"0 15px 0 10px",
    minHeight: "36px",
    width:"auto !important",
    "& > div":{
      display: "table-cell",
      alignItems: "baseline",
      verticalAlign:"middle",
    "& > div":{  
        width:"100%",
        marginLeft: "10px",
    },
    },
    "& span span":{
      marginLeft:"12px",
    }
  },
  clearanceWizardQuesRowAns:{
    display:"flex",  
    paddingLeft:"0",
    minHeight: "36px",
    width:"auto !important",
    paddingRight:"15px",
    "& > div":{
      display: "flex",
      alignItems: "baseline",
    "& > div":{  
            width:"100%",
           marginLeft: "10px",
    },
    },
    "& span span":{
      marginLeft:"12px",
    }
  },
  clearanceWizardQuesRowUnAns:{
   padding:"0 15px 0 0",
    width:"auto !important",
    "& > div":{
      display: "flex",
      alignItems: "baseline",
    "& > div":{  
            width:"100%",
           marginLeft: "0",
    },
    },
    "& span span":{
      marginLeft:"12px",
    }
  },
  clearanceWizardDetails:{
    fontSize:"14px",
    fontWeight:"600",
  },
  
 
  clearanceWizardTrackNotesContainer:{
    "& svg":{
      fontSize: "22px",
      verticalAlign: "middle",
    }
  },
  clearanceWizardStatusColor:{
    margin:"10px 0 15px 0",
    "& span":{
      padding: "9px 16px",
      borderRadius: "3px",
      fontSize: "15px",
    }
  },
  clearanceWizardStatus:{
    display:"flex",
    alignItems: "center",
    justifyContent: "flex-start",
    "& > div":{
      marginRight:"15px",
      marginBottom:"10px",
      textAlign:"left",
      width:"100%",
    },
    "& button":{
      marginRight: "0",
      marginBottom: "20px",
      marginTop: "10px",
      float:"right"
    },
  },
  clearanceWizardArtwork:{
    marginLeft:"10px",
    marginBottom:"10px",
    position:"relative",
    "&   button":{
      margin:"10px 0 !important",
      // position: "absolute",
      // top: "0",
      // left: "0",
      // right: "0",
      // opacity:"0",
      // textAlign:"center",
       background: "#737373",
      "& svg":{
        margin:"0",
      },  
      "&.MuiIconButton-root":{
        margin:"2px"
      }
    },
    "&:hover":{
      "& button":{
        opacity:"1"
      }
    },
    "&:active":{
      "& button":{
        opacity:"1"
      }
    },
    "&:focus":{
      "& button":{
        opacity:"1"
      }
    },
"& .notPermitted":{
  padding:"8px 0", 
  textAlign: "center"
}
  },
  clearanceWizardPlayButton:{
    width:"40px",
    height:"32px",
    minWidth:"inherit",
    marginLeft:"20px",
    "& span":{
      fontSize:"28px !important",
      lineHeight: "1px",
    },
  },
  clearanceWizardAvatar:{
    width: "40px",
    height: "40px",
    borderRadius: "3px",   
  },
  clearanceWizardTrackTitle:{
    fontSize:"15px!important",
    fontWeight: "600!important",
    display:"block !important",
    color: "#fff !important",
    textTransform: "none !important",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    marginBottom:"0 !important"
  },
  clearanceWizardTrackDetailSpan:{
    minWidth:"60px !important",
  },
  clearanceWizardTrafficLight:{
    minWidth:"25px",
    height:"25px",
    borderRadius:"50%",
    margin: "5px 10px 5px 0px",
  },
  clearanceWizardTrafficWrapper:{
    display: "flex",
    alignItems: "center", 
    fontSize: "1.1em",
    margin:"0 !important",
  },
  zeroPadding:{
    paddingTop:"0 !important",
    fontSize:"0.8em",
  },
  clearanceWizardClearButton:{
    background:"#DBBF63",
    color:"#000",
    border:"1px solid #DBBF63",
    "&:hover":{
      border:"1px solid #DBBF63",
      color:"#DBBF63",
    }
  },
  clearanceWizardNotesView:{
    padding:"10px 0",
    fontWeight: "400",
     fontSize:"1em",
    "& label":{
      display: "block",
      fontWeight: "600",
       fontSize:"1em",
      marginBottom: "8px",
    },

  },
  trackhdr : {
     fontSize:"1em",
    display: "flex",
    padding: "10px",
    marginTop: "15px",
    alignItems: "center",
    "& .MuiAvatar-root":{
      marginRight: "12px",
    }

  },

  trackhdrcard : {
     fontSize:"1em",
    display: "flex",
    alignItems: "center",
    marginBottom: "10px",
    "& .MuiAvatar-root":{
      marginRight: "12px",
    }

  },

  gate : {

    
    padding: "10px",
    marginTop: "15px",
    alignItems: "center",
    "& .MuiAvatar-root":{
      marginRight: "12px",
    }

  },
  prop : {

    display: "flex",
    padding: "10px 0",
    borderBottom: "1px solid #5a5a5a"

  },
  proplabel : {

    color: "#dcdcdc",
    width: "70%",
    display: "inline-block",
     fontSize:"1em",
    verticalAlign: "top"

  },
  propval : {

     fontSize:"1em",
    verticalAlign: "top",
    color : "green"

  },
  buildDetailsBlock:{
    display:"flex",
    padding:"15px",
    fontSize: "14px",
    background: "#5a5a5a",
    borderRadius: "3px",
    margin: "10px 20px 10px 0px",
    alignItems: "center",
  },
  buildName:{
    width:"-webkit-fill-available",
    width:"100%",
  },

  buildQuestionBlock:{
    display:"flex",
    padding:"15px 20px",
    fontSize: "14px",
    background: "#5a5a5a",
    borderRadius: "3px",
    margin: "10px 20px 10px 0px",
    alignItems: "center",
    "& .MuiSelect-select":{
      padding: "8px 35px 8px 10px",
    },
    "& label":{
      display:"block",
      margin:"0px 0 7px 0",
    },
  },
  buildQuestionSingleBlock:{
    width:"100%",
  },
  buildQuestionTypeBlock:{
  marginLeft:"10px",
},
  buildAddButton: {
    background: "#0c853e",
    boxShadow: "none",
    color: "#fff",
    textTransform: "none",
    fontWeight: "400",
    margin: "0px 0px 0px 10px",
    padding: "8px !important",
    fontSize:"12px",
    border: "1px solid #005026",
    cursor:"pointer",
    borderRadius: "5px",
    height: "33px",
    "&:hover": {
        background: "#000",
        color: "#29D211",
    },
    "& svg":{
      fontSize: "15px",
    },
},
buildSaveButton:{
  background: "#0c853e",
  boxShadow: "none",
  color: "#fff",
  textTransform: "none",
  fontWeight: "400",
  margin: "0px",
  padding: "8px 15px !important",
  fontSize:"12px",
  border: "1px solid #005026",
  cursor:"pointer",
  borderRadius: "5px",
  height: "33px",
  marginTop:"10px",
  "&:hover": {
      background: "#000",
      color: "#29D211",
  },
  "& svg":{
    fontSize: "15px",
  },
},
buildCloseButton:{
  background: "#5f5d5d",
  boxShadow: "none",
  color: "#fff",
  textTransform: "none",
  fontWeight: "400",
  margin: "0px 0px 0px 10px",
  padding: "8px 15px !important",
  fontSize: "0.8em",
  border: "1px solid #7b7777",
  cursor:"pointer",
  borderRadius: "5px",
  height: "33px",
  "&:hover": {
      background: "#000",
      color: "#29D211",
  },
  "& svg":{
    fontSize: "15px",
  },
},
buildKeyAddButton:{
  background: "#0c853e",
  boxShadow: "none",
  color: "#fff",
  textTransform: "none",
  fontWeight: "400",
  margin: "0 0px 0px 10px",
  padding: "8px 15px !important",
  fontSize:"0.8em",
  border: "1px solid #005026",
  cursor:"pointer",
  borderRadius: "5px",
  height: "33px",
  "&:hover": {
      background: "#000",
      color: "#29D211",
  },
  "& svg":{
    fontSize: "15px",
  },
},
buildTrashButton: {
  color: "#ff5f84",
  boxShadow: "none",
  color: "#fff",
  textTransform: "none",
  fontWeight: "400",
  margin: "0px 0px 0px 10px",
  padding: "8px !important",
  fontSize:"12px",
  minWidth: "inherit",
  cursor:"pointer",
  borderRadius: "5px",
  height: "33px !important",

  width: "33px!important",
  "&:hover": {
      background: "rgba(255, 255, 255, 0.08)",
      color: "#f1527e",
  },
  "& svg":{
    fontSize: "15px",
  },
},
 
tableFilterInput: {
  width:"100%",
  "& p.Mui-error":{
    margin:"8px 0",
    pointerEvents: "none",
  },
  "& input": {
    borderRadius: "5px !important",
    padding: "8.5px 27px 8.5px 8.5px",
     fontSize:"0.8em",
    background:"#2d2d2d",
  },
  "& div": {
    borderRadius: "5px !important",
    width:"100%",
    margin:"0 !important",
    justifyContent: "flex-start",
  },
  "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline":{
    borderColor: "#46af22 !important",
  }
},
tableFilterInputChips:{
  width:"100%",
  "& p.Mui-error":{
    margin:"8px 0",
    pointerEvents: "none",
  },
  "& .MuiOutlinedInput-root":{
    padding:"5px  !important",
  },
  "& input": {
    borderRadius: "5px !important",
    padding: "0px 27px 0px 8.5px",
     fontSize:"12px",
    background:"#2d2d2d",
  },
  "& div": {
    margin:"0 !important",
    justifyContent: "flex-start",
  },
  "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline":{
    borderColor: "#46af22 !important",
  },
  "& .MuiChip-root":{
    margin:"2px !important",
    wordBreak: "break-all",
    whiteSpace: "nowrap",
    baselineShift: "inherit",
    padding:"1px 2px 2px 0px",
    height: "inherit",
    "& .MuiChip-label":{
      whiteSpace: "break-spaces",
    },
    "& .MuiChip-deleteIcon":{
      marginRight:"0"
    }
  }
},
nameTextField:{
  width:"100%",
  fontSize:"12px",
  "& textarea":{
    maxWidth: "100%",
    background: "#505050",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    borderRadius: "4px",
    padding: "10px!important",
    boxSizing:" border-box",
    color:"#fff",
    outline:"#46af22",
  resize: "vertical",
    "&:focus-visible":{
      borderColor: "#46af22 !important",
    }
     
  },
    "& > div":{
    width:"100%",
    display:"block",
    flexDirection: "inherit",
    "& p.Mui-error":{
      margin:"5px 0 0px 0",
      pointerEvents: "none",
    },
  }
},

editClearaneName:{
  minWidth:"338px",
  "& input":{
    // width: "350px",
  }
},
buildOptionWrap:{
    padding: "20px",
    borderRadius: "5px",
    padding:"5px  30px",
     fontSize:"1em",
   "& > div":{
    display: "flex",
    alignItems: "center",
    marginBottom: "10px",
   }
},
buildOptionWrapInternal:{
  padding: "20px",
  borderRadius: "5px",
  padding:"5px 0px",
   fontSize:"1em",
 "& > div":{
  display: "flex",
  alignItems: "center",
  marginBottom: "10px",
 },
 "& input":{
  minWidth:"inherit",
  padding:"8px 12px !important",
 },
 "& [data-rbd-droppable-id=\"droppable\"]":{
   padding:"0 !important",
 }
},

buildOptionSpan:{
  marginRight:"10px",
  fontSize: "0.8em",
 },
 buildOptionSpanValue:{
  marginRight:"10px",
  marginLeft:"10px",
  fontSize: "0.8em",
 },
buildOptionContainer:{
  display:"flex",
  border: "1px solid #404040",
  alignItems: "center",
  padding:" 5px 10px",
  borderRadius: "4px",
  margin:" 0 !important",
  background: "#292828",
},
buildOptionLabel:{
  width:"-webkit-fill-available",
  width:"100%",
  fontSize: "0.8em",
},
buildRulesDiv:{
  height: "calc(100% - 126px)",
  overflow: "scroll",
  position: "absolute",
  width:" calc(100% - 52%)",
  padding: "0 30px",
},
buildParamsDiv:{
  overflow:"scroll",
  height:"calc(100% - 126px)",
  position: "absolute",
  padding: "0 10px 0 50px",
},
buildParamstitle:{
  fontSize:"20px",
  padding:"10px",
  borderBottom: "1px solid #616161",
  marginBottom: "0",
},
buildRuleName:{
  width:"-webkit-fill-available",
  width:"100%",
  "& div":{
    whiteSpace: "initial",
  }
},
buildRuleRow:{
    border: "1px solid",
    marginBottom: "5px",
    borderRadius: "3px",
    margin: "10px 0",
    padding: "4px 10px",
},
buildRuleContainer:{
  padding: "15px 25px",
    position: "relative",
    height: "100vh",
    "& li":{
      border:"1px solid #3E3E3E",
      marginRight: "20px",
    },
},
editorRuleLabel:{
    color: "#DEDEDE",
    margin: "5px 0 5px 0",
    display: "block",
    fontSize: "0.8em",
    textTransform: "uppercase",
},
ruleBuildTopContainer:{
  padding: "10px 20px 20px 20px",
  background: "#222",
},
buildNameBlock:{
  paddingBottom: "10px",
},
buildNameBlocktags:{
  padding: "10px",
},
triggerInputName:{
  width:"-webkit-fill-available",
  width:"100%",
},
buildRuleSaveButton:{
  background: "#0c853e",
  boxShadow: "none",
  color: "#fff",
  textTransform: "none",
  fontWeight: "400",
  margin: "0px",
  padding: "8px 15px !important",
  fontSize: "0.8em",
  border: "1px solid #005026",
  cursor:"pointer",
  borderRadius: "5px",
  height: "33px",
  "&:hover": {
      background: "#000",
      color: "#29D211",
  },
  "& svg":{
    fontSize: "15px",
  },
  "& .MuiCircularProgress-colorPrimary": {
    color: "#ffffff",
    width: "15px !important",
    height: "15px !important",
    marginLeft: "5px",
},
},
buildRuleButtonContainers:{
  textAlign:"right",
},
buildRuleAddButton:{
    background: "#0c853e",
        boxShadow: "none",
        color: "#fff",
        textTransform: "none",
        fontWeight: "400",
        margin: "10px 10px 0px 0",
        padding: "6px 10px",
        fontSize:"0.8em",
        border: "1px solid #005026",
        "&:hover": {
            background: "#000",
            color: "#29D211",
        },
        "& svg":{
          fontSize: "19px",
        },
},
buildParamsAddButton:{
  marginTop:"0",
},

buildParamsAutoComplete:{
},

buildRuleAddButtonInternal:{
  margin: "5px 10px 0px 0",
},

buildEditorBlock:{
   fontSize:"12px",
  borderRadius: "3px",
  margin: "10px 0px 10px 0px",
  position: "absolute",
  height: "calc(100% - 334px)",
  overflow: "auto",
  right: "8px",
  paddingBottom: "20px",
  // width: "calc(100% - 50px)",
  left: "26px",

},
ruleGate:{
  padding:"15px 0",
   fontSize:"1em",
  borderTop:" 1px solid #686868",
  borderRadius: "3px",
  margin: "0px 20px 0px 0px",
  marginTop: "20px",
 
},
ruleTriggerCondition:{  
  display:"flex",
  borderBottom: "1px solid #272727",
  paddingBottom: "15px",
  paddingTop: "15px",
  paddingRight: "15px",
    alignItems:" baseline",
    fontSize:"0.8em",
  "& .MuiSelect-select":{
    padding: "7px 37px 7px 10px",
  },
},
ruleTriggerConditionInternal:{
  display:"flex",
  alignItems: "center",
  borderBottom: "1px solid #272727",
  paddingBottom: "15px",
  padding: "15px",
  borderRadius:"5px",
    alignItems:" baseline",
  "& .MuiSelect-select":{
    padding: "7px 37px 7px 10px",

  },
  "&:hover":{
    background:"#2e2e2e",
  }
},
ruleTriggerBlock:{ 
  marginLeft: "15px",
  display:"flex",
  width:"-webkit-fill-available",
  width:"100%",
},
triggerLabel:{
   "& div.MuiAutocomplete-endAdornment":{
    width:"30px",
    maxWidth: "inherit",
   },
  width:"-webkit-fill-available",
  width:"100%",
  "& div":{
    width:"-webkit-fill-available",
    width:"100%",    
  },
  "& input.MuiAutocomplete-input":{
    fontSize:"0.75em",
    padding:"2px 5px !important",
   
  },
  "& .MuiAutocomplete-inputRoot":{
    background: "#2d2d2d",
  },
},
ruleTriggerInput:{
  "& input.MuiAutocomplete-input":{
    padding:"8px 5px !important",
  }
},
ruleConditionTagName:{
  marginRight:"10px",
  marginBottom: "5px",
    display: "block",
    color: "#62C2E6",
},
ruleTriggerConditionChild:{
  // display: "block",
  // alignItems: "baseline",
  width:"-webkit-fill-available",
  width:"100%",
  border: "1px dashed #767474",
  borderRadius: "5px",
  padding: "10px 0px 10px 10px",
},
ruleTriggerConditionChildOR:{
  display: "flex",
  alignItems: "center",
  marginBottom:"5px",
  "& .triggerLabel":{
    marginLeft:"10px",
  }
},
rules:{
  width:"100%",
  fontSize:"1em",
},
ruleConditionTag:{
  background: "#438eab",
  padding: "7px 12px",
  borderRadius: "3px",
  marginRight:"10px",
},
ruleConditionName:{
    display:" inline-block",
    margin: "10px 5px",
},

ruleConditionOR : {
  color : "#FCE939",
  textDecoration:"underline",
  marginRight: "5px", 
},
buildRuleAddOption:{
  background: "#0c853e",
        boxShadow: "none",
        color: "#fff",
        textTransform: "none",
        fontWeight: "400",
        margin: " 0 0 0 10px",
        padding: "6px 7px",
        fontSize:"12px",
        minWidth:"inherit",
        border: "1px solid #005026",
        "&:hover": {
            background: "#000",
            color: "#29D211",
        },
        "& svg":{
          fontSize: "19px",
        },
},
ruleBuildRemove:{
  background:"none",
  minWidth:"inherit",
  color:"#fff",
  padding: "10px",
  marginLeft:"10px",
  maxHeight: "33px !important",
},
editorRuleStatus:{
  "& .MuiSelect-select":{
    padding: "8px 35px 8px 10px",
    maxWidth:"400px",
  },
},
ruleTriggerLabel:{
  color: "#FCE939",
  display: "inline-block",
  borderRadius: "3px",
  margin: "0 0 5px 0",
  textDecoration: "underline",
  display: "block",
  clear: "left",
},
ruleTriggerLabelInternal:{
  color: "#FCE939",
  display: "inline-block",
  borderRadius: "3px",
  margin: "0 0 5px 0",
  textDecoration: "underline",
  display: "block",
  clear: "left",
  fontSize:"12px",
},
globalCreateInputInternal:{
"& .MuiListSubheader-root":{
  lineHeight: "15px !important",
  padding: "10px !important",
   fontSize:"1em",
}
},
globalCreateStatus:{
  padding:"0 0px 10px 10px",
},
globalNameBlock:{
  display:"flex",
  "& > div":{
    padding: "5px  0",
    width:"100%",
  },
  "& .MuiSelect-select":{
    padding: "10px 30px 10px 10px",
    background:"#2d2d2d",
  },
  "& .MuiOutlinedInput-root":{
    width:"100%",
  },
  "& input":{
    background:"#2d2d2d",
  }
},
ruletriggerOption:{
  display:"flex",
  margin:"0 10px",
  minWidth: "200px",
  alignItems: "baseline",
},
buildRuleMainContainer:{
  background:"#000",
},
ruleBuildButtons:{
  display:"flex",
  marginRight: "10px",
},
ruleBuilderMoveIcon:{
  minWidth: "inherit",
  width: "31px",
  maxHeight: "31px",
},
clearanceHeaderInputs:{
  "& input":{
    background: "#585858",
  },
  "& > span":{
    paddingBottom:"5px",
  }
},
indentORblock:{
  paddingLeft: "20px",
},
ruleConditionBlock:{
  display: "inline-block",
 "& span":{
  margin:"0 5px 0 0px",
  float: "left",
 },
},
ruleBuilderTreeView:{
  "& .MuiTreeItem-label":{
    fontSize:"12px",    
  },
  "& > .MuiTreeItem-root":{
    padding: "10px 5px",
    borderRadius: "3px",
    marginTop: "10px",
    "& .MuiTreeItem-root":{
      border:"none",
    }
  }
},
ruleBuilderLoding:{
  position:"absolute",
  left:"0",
  right:"0",
  top:"50%",
  width: "100%",
  textAlign: "center",
  "& .MuiCircularProgress-colorPrimary":{
    color: "green",
},
},
clearanceOverriddenContainer:{
  padding:"15px 0",
},
clearanceOverridden:{
  padding:"0",
  display:"flex",
  alignItems:"center",
  "& span":{
    fontWeight: "400",
    fontSize: "12px",  
    margin: "5px 0",
    "&.label-title":{
      width:"80px"
    }
  }
},
clearanceGreen:{
  "& div":{
    fontSize:"12px",
    color:"#fff",
  }, 
},
clearanceWizardSingleTrackUnCleared:{
  color:" #ffbc00",
  fontWeight: "400",
   fontSize:"1em",
  background: '#eebc4d',
  padding: "5px",
  borderRadius: "3px",
  color: "#000",
  marginTop:"5px",
},
actionMenuIcon:{
  marginRight:"10px",
  fontSize: "18px",
},
dialogWrapper:{
  fontSize:"12px",
 
},
dialogLivePerform:{
  "& .MuiPaper-root":{
    minWidth:"400px"
  },
  "& .MuiDialogTitle-root":{
    paddingBottom:"0"
  },
  "& .MuiDialogActions-root":{
    padding: "15px 8px",
  }
},
isrcLabel:{
  "& .spanContainer":{
    display: "block",
    margin: "10px 0 5px 0",
  },
  "& a":{
    color:"#FFB800",
    fontSize:"13px",
  }
},
hintText:{
  color:"#B0B0B0",
  fontSize:"13px",
  margin: "10px 0",
    display: "block",
},
dialogYesButton:{
  background:"#118543",
  fontSize:"12px",
  "&:hover":{
    background:"#000",
    color:"#118543",
  }
},
dialogNoButton:{
  background:"#505050",
  fontSize:"12px",
  "&:hover":{
    background:"#000",
    color:"#fff",
  }
},
varientClass:{
  background:"#eebc4d",
  color: "#000",
    padding: "3px 6px",
    fontSize: "11px",
    marginTop: "5px",
    fontWeight: "400",
    borderRadius: "3px",
    margin: "0",
    "&.Mui-disabled":{
      background:"#A8003B",
      color: "#fff !important",
      "& span":{
        color: "#fff !important",
      },
      "& svg":{
        color: "#fff !important",
      }
    },
    "&:hover":{
      background:"#000",
      color: "#eebc4d",
      "& span":{
        color:"#fff !important"
      }
    },
    "& .MuiCircularProgress-colorPrimary":{
      width: "20px!important",
    height: "20px!important",
    margin: "0!important",
    "& svg":{
      color:"#fff !important",
    },
    }
},

clearanceWaitingLoader:{
  textAlign: "center",
  padding: "10px",
  fontWeight: "400",
  "&  .MuiCircularProgress-colorPrimary":{
      color: "#3f51b5",
      width: "15px !important",
  height: "15px !important",
  
  }
},

editButton:{
  background:"#126d94",
  fontSize: "12px",
  padding:"5px",
  marginBottom:"12px",
  textTransform:"none",
  marginLeft: "10px",
  minWidth: "inherit",  
  "&:hover":{
    background:"#5676a0",
    opacity: "0.8",
  },
  "& svg":{
  marginRight:"0 !important",
  fontSize:"14px",
  }, 
},
inlineWizardLink:{
 color:"#26B70B",
 background:"none",
 display: "block",
 textTransform:"none",
 fontSize:"1em !important",
 padding:"0",
 "& span":{
  textTransform:"none !important",
  fontWeight:"bold",
  wordBreak: "break-word",
  whiteSpace: "pre-wrap",
 },
 "&:hover":{
   background:"none",
   color:"#7bef94",
   textDecoration:"underline",
 },
 "&:focus":{
  background:"none",
},
 "& .MuiCircularProgress-indeterminate":{
  width: "10px !important",
  height: "10px !important",
  marginLeft: "10px",
  position:"absolute",
 }
},
clearanceDialogBox:{
  width: "340px",
  marginBottom: "19px",
  "& h2":{
    lineHeight: "1 !important",
    marginTop: "10px",
  }
},
cTagsInputDiv:{
  "& .MuiOutlinedInput-input": {
    padding: "6.5px 14px",
},
},
globalNameBlockinternal:{
  fontSize:"1em",
  display:"inherit",
  "& > div":{
    width:"inherit",
    padding:"5px  10px",  
    },
  "& .MuiAutocomplete-inputRoot":{
  padding:"9px",
  },
  "& input":{
    background:"#2d2d2d",
  }
},
globalButtonsList:{
  padding:"0",
  textAlign:"right",
},
buildNametags:{
  padding:"0 10px",
},
clearanceEditIcon:{
  fontSize:"17px",
  marginRight: "7px !important",
      "& span":{
        color: "#eebc4d",
      }
    } ,

insideLoader:{
  width:"10px !important",
  height:"10px !important",
  color:"#fff",
  margin:"0 5px"
},
stickyHeader:{
  background:"#2b2e2f",
  padding:"0 10px",
  top: "-2px",
  position: "relative",
  "& .MuiGrid-spacing-xs-3 > .MuiGrid-grid-xs-8":{
    // padding: "12px 12px 0px 12px",
  },
  "& .MuiGrid-spacing-xs-3 > .MuiGrid-grid-xs-4":{
    padding: "12px 12px 0px 12px",
  },
  "& button.MuiIconButton-root":{
    opacity:"1",
    width: "35px",
    height: "35px",

  },
  "&:hover button.MuiIconButton-root":{
    opacity:"1",
    width: "35px",
    height: "35px",

  },
  "& button.MuiIconButton-root.Mui-focusVisible":{
    opacity:"1",
    width: "35px",
    height: "35px",
  },
  "&:hover .MuiAvatar-root img":{
    // display:"none !important",
  },
   "&:focus-within .MuiAvatar-root img":{
    // display:"none !important",
  },
  "&:active .MuiAvatar-root img":{
    // display:"none !important",
  },
  "&:focus .MuiAvatar-root img":{
    // display:"none !important",
  },

  "&:focus .MuiAvatar-square":{
    // opacity:"0 !important",
  },
  "&:active .MuiAvatar-square":{
    // opacity:"0 !important",
  },
  "&:focus-within .MuiAvatar-square":{
    // opacity:"0 !important",
  },
  "&:focus-within button":{
    opacity:"1 !important",
    width: "35px",
    height: "35px",
  },

  "&:hover .MuiAvatar-root .MuiAvatar-fallback":{
    display:"none !important",
  },
  "&:hover .MuiAvatar-root":{
    background: "#545454 !important",
  }
},
stickyWrapper:{
  zIndex:"99",
},
clearanceWizardTrackDetails:{
  marginBottom:"4px",
  display:"flex",
  alignItems: "baseline",
  "& .MuiTextField-root":{
    marginBottom:"5px",
  },
  "& span":{
    display: "block",
    fontSize: "0.7em",
    fontWeight: "400",
    color: "#F5E9DE",
    textTransform: "uppercase",
    marginBottom: "3px",
    minWidth: "190px",
    marginRight: "5px",
  },
  "& >div":{
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    fontSize:"0.75em",
    display:"flex",
  },
  "& svg":{
    fontSize: "22px",
    verticalAlign: "middle",
  }
},
clearanceRemoveMinWidth:{
  "& span":{
    minWidth: "90px",
  },
},
appbarTitleContainer:{
  width:"-webkit-fill-available",
  width:"100%",
  padding: "0 15px",
  "& button":{
    margin:"0 0 10px 10px",
    float: "right",
  }
},
appbarsubTitle:{
  fontSize: "11px",
    color: "#e6e6e6",
    margin: "6px 0",
    display: "flex",
    display:"none",
},
appbarsubTitleIcon:{
  color:"#fff",
  fontSize:"14px",
    marginRight: "8px",
  "& path":{
    stroke: "#fff",
  }
},
clearanceFormStatus:{
  width:"22px",
    height:"22px",
    borderRadius:"50%",
},
clearanceFormStatus:{
  whiteSpace:"nowrap",
  "& span":{
    display: "flex",
    fontSize: "14px",
    fontWeight: "400",
    alignItems: "center",
    marginBottom: "0",
    marginRight: "10px",
    "& span":{
      marginRight:"10px",
    }
  },  
  fontSize: "15px",
  paddingTop:"12px",
},
clearnaceSaveButton:{
  margin:"0 5px 0 5px",
  height: "33px !important",
  padding: "6px 10px !important",
  whiteSpace: "nowrap",
},
clearanceStatusResult:{
  "& > div":{ 
    justifyContent: "flex-start",
    margin:"0 0 0 15px !important",
  }, 
},
clearanceHeaderErrWrapper:{
  margin: "8px 0 0 0",
  color:"#FFD1D1 !important",
  fontSize:"12px",
},
appbaRuleValue:{
  marginRight:"3px",
},
appbaRuleName:{
  margin:"0 3px",
},
clearanceWizardTrackFlex:{
  display:"flex",
  "& > div":{
    marginRight:"15px",
  }
},
clearanceWizardGlobalDetails:{
  width:"100%",
  overflow:"hidden"
},
clearanceWizardTrafficAdditionlMargin:{
  margin:"0  20px!important",
},
clearanceStatusWrapper:{
  "& .ClearanceStatusContainer":{
    display:"flex",
    alignItems: "center",
    background: "#323232",
    padding: "3px 15px 3px 8px",
    borderRadius: "5px",
    fontSize: "16px",
  }
},
clearaneAddMessage:{
  textAlign:"right",
  color:"#fff",
  cursor:"pointer",
  "& button":{
    minWidth:"inherit",
  }
},
clearanceSaveContainer:{
  display:"flex",
  alignItems: "center",
  marginLeft:"20px",
  "& .editSingleTracks":{
    padding:"10px !important",
    margin:"0"
  },
  "& .MuiButton-root":{
    padding:"5px 15px",
  }
},
batchClearanceSaveContainer:{
  display:"flex",
  alignItems: "center",
  marginLeft:"10px",
  "& .editSingleTracks":{
    padding:"10px !important",
    margin:"0"
  },
  "& .MuiButton-root":{
    padding:"5px 15px",
  }
},
clearanceResultsWrapper:{
  display:"flex",
  alignItems: "center",
  justifyContent:"flex-end"
},
batchClearanceResultsWrapper:{
  display:"flex",
  alignItems: "center",
  justifyContent:"flex-start"
},
clearanceWizardSwitch:{
  color:"#00DCFF",
  margin:"12px ​20px 0 0px",
  "& .MuiSwitch-root":{
  transform:"scale(0.9)",
  marginRight: "7px",
  "& .MuiSwitch-colorSecondary.Mui-checked":{
    color:"#00DCFF!important",
  },
  "& .MuiSwitch-colorSecondary.Mui-checked + .MuiSwitch-track":{
    backgroundColor:"#00DCFF!important",
  }
}
},
additionalPaddingLeft:{
  paddingLeft:"20px"
},
genreDropdown:{
  display:"flex",
  alignItems: "center",
  marginBottom:"15px",
  "& > span":{
    fontSize:"11px",
    margin:"0 5px 0 0",
    color: "#fff",
    whiteSpace: "nowrap",
  },
  "& > label":{
    fontSize:"11px",
    margin:"0 10px  0 0px",
    color: "#F5E9DE",
    textTransform:"uppercase",
    whiteSpace: "nowrap",
    width:"280px"
  },
  "& .MuiSelect-outlined.MuiSelect-outlined": {
    paddingRight:" 32px",
    background: "#785b0d",
    paddingTop: "9px",
    paddingBottom: "8px",
    textAlign:"left", 
  },
  "& .MuiFormControl-root":{
    width:"100%",
  },
  "& .MuiOutlinedInput-root":{
    width:"100%",
  },
  "& .Mui-error":{
    fontSize:"12px",
    whiteSpace: "nowrap",
    marginLeft:"10px",
  },
  "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline":{
    borderColor:"#46af22",
  },

  "& textarea":{
    color: "#fff",
  width:" 100%",
  border: "1px solid #93804f",
  resize: "none",
  padding: "10px",
  fontSize: "0.8em",
  maxWidth: "100%",
  background: "#725a1a",
  boxSizing: "border-box",
  maxHeight: "220px",
  fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif , 'Segoe UI', 'Roboto', 'Oxygen'",
  borderRadius: "3px",
  outline:"none",
  "&:focus":{
    borderColor: "#46af22 !important",
  },
  "&:hover":{
    borderColor: "#46af22 !important",
  },
  }
},
genreDropdownWidth:{
  width:"100%",
  "& .MuiSelect-selectMenu":{
    minWidth: "inherit !important",
    maxWidth: "inherit !important",
  }
},

clearanceTrackDataShow:{
  // whiteSpace: "normal !important",
  // overflow: "inherit !important",
  marginLeft: "3px",
  whiteSpace: "nowrap",
  overflow: "hidden", 
  textOverflow: "ellipsis",
},
globalBlock:{
  padding:"0 0 10px 0",
},
clearanceDeadline:{
    "& .MuiOutlinedInput-input":{
    padding:"9px 14px",
    fontSize:"12px",
  },
  "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline":{
    borderColor:"#46af22",
  },
  "& input":{
    background: "#725a1a",
    padding:"10px 27px 10px 8.5px !important",
  },
  "& .MuiSelect-select":{
    paddingTop: "4px",
  paddingBottom: "4px",

  },
  "& .MuiSelect-outlined.MuiSelect-outlined":{
    padding: "8px 10px !important",
  marginTop: "0",    
  },
  "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": {
    borderColor: "#46af22 !important",
  },
  "& .MuiAutocomplete-hasClearIcon": {
    width: "100%",
    margin: "0",
    border: "none",
    background: "#8e742e",
    "& input": {
      padding: "10px!important",
      fontSize: "12px",      
    background: "#8e742e",
    },
    "& .MuiOutlinedInput-root":{
      padding:"0",
    }
  },
},
clearanceHeaderAddPadding:{
  padding:"0 0 20px 0",
},
synopsisField:{
  margin: "0 0 15px 0",
  width:"-webkit-fill-available",
  width:"100%",
  "& label":{
    marginLeft: "0",
  }
},
additionalPadding:{
  paddingTop:"10px",
},
wizardHelpIcon:{
  marginTop:"8px",
  marginRight:"10px"
},
  clearanceGenre:{
    width:"100%",
    "& .Mui-error":{
      margin:"8px 0",
      display:"block",
    }
  },
  clearanceTools:{
    display:"flex",
    alignItems: "center",
    justifyContent: "flex-start",
    "& .MuiButton-text":{
      fontSize:"12px",
    lineHeight: "1",
    padding: "10px 15px !important",
    width:"auto!important",
    marginLeft: "auto",
    minWidth:"120px"
    }
  },
  emailIcon:{
    fontSize:"26px !important",
    marginTop: "4px",
  },
  sourceTrackContainer:{
    display: "flex",
    fontSize: "12px",
    marginRight: "10px",
    alignItems: "center",
    "& div":{
      wordBreak: "break-word",
      whiteSpace: "break-spaces",
      marginLeft: "3px",
    },
    "& span":{
      display: "block",
      fontWeight: "400",
      color: "#F5E9DE",
      textTransform: "uppercase",
      marginBottom: "0",
      marginRight: "5px",
      minWidth: "190px",
      fontSize: "11px",
    },
},

  editPerformer:{
    "& input":{
      padding: "8.5px 27px 8.5px 8.5px",
       fontSize:"0.8em",
      borderRadius:" 5px !important",
    },
    "& .MuiOutlinedInput-notchedOutline":{
      top:"-7px",
    }
  },
  overrideHelp:{
    margin: "10px",
    "& button":{
      padding: "0",
      margin:"0 10px 0 5px",
      width: "30px",
      minWidth: "inherit !important",
      textAlign: "center",
      "& svg":{
        margin:"0 !important"
      }
    }
  },
  addORCondition:{
    fontSize:"1.3em",
  },
  clearanceMesageIcon:{
    minWidth: "37px",
    height: "35px",
    borderRadius: "3px",
    marginTop: "8px",
    padding:"0!important",
    "& span":{
      margin: "0!important",
      padding:"0!important",
    }
  },
  clearanceWizardMsgIcon:{
    margin: "4px 10px 6px 10px",
    display:"none",
    minWidth: "35px",
    height: "35px",
    borderRadius: "3px",
  },
  emailButton:{
    lineHeight: "1",
    minWidth: "35px",
    height: "35px",
    borderRadius: "3px",
  },
  tableNotes:{
    "& button":{
      margin:"0",
    },
  "& .MuiSelect-selectMenu":{
    paddingTop:"8px",
    paddingBottom:" 7px",
    width: "100%",
    background: "#2d2d2d",
  },
  "& .MuiOutlinedInput-root":{
    width: "100%",
  }
},
activeRadio2:{
  position: "relative",
  background:"#16A168 !important",
  "&:after":{
    content: "''",
    borderLeft: "9px solid transparent",
    borderRight: "10px solid transparent",
    borderBottom: "9px solid #212121",
    position: "absolute",
    left: "0",
    right: "0",
    width: "2px",
    margin: "0 auto",
    bottom: "0",
    display: "block",
    textAlign: "center",
  }
},
activeHover:{
  "&:hover":{
    background:"#16A168 !important",
  },
  "& label":{
    padding:"10px 15px",
  }
},
activeRadio:{
  background:"#16A168 !important",
  opacity:"1 !important",
  position: "relative",
  "& label":{
    color:"#fff !important",
  },
  "&:after":{
    content: "''",
    borderLeft: "9px solid transparent",
    borderRight: "10px solid transparent",
    borderBottom: "9px solid #212121",
    position: "absolute",
    left: "0",
    right: "0",
    width: "2px",
    margin: "0 auto",
    bottom: "0",
    display: "block",
    textAlign: "center",
  }
},

loadingText:{
  fontSize:"13px"
},
iconButtonsGroup:{
  display:"block",
  "& label":{
    color:"#fff",
    fontWeight:"normal",
    fontSize: "12px",
    margin:"0",
    textAlign:"center",
    cursor:"pointer",
    "&.clearanceLabelName":{
      display:"block",
      textAlign:"left",
    },
  },
  "& input":{
    position:"absolute",
    left:"-9999px",
  },
  "& div":{
    display:"inline-block",
    cursor:"pointer",
    verticalAlign:"top",
    marginRight: "10px",
    borderRadius: "5px",
    // padding: "10px 15px",
    width: "150px",
    boxSizing:" border-box",
    
    "&.singleLabel":{
      display:"block",
      width:"100%",
      padding:"0",
      "& label":{
        color:"#fff",
        fontWeight:"bold",
        fontSize:"13px",
        margin:"0 0 5px 0",
        paddingLeft:"0",
      }
    }
  }
},
buildNotesAddButton:{
  margin:"0",
  padding:"5px 10px 4px 10px",
},
boldSeperator:{
  color:"yellow",
  margin:"0 2px"
},
wizardPopup:{
  maxWidth:"84%",
  margin:"0 auto",
  "& > div[aria-hidden='true']":{
    backgroundColor:"rgba(0, 0, 0, 0.9) !important",
  }
},
stickMainContainer:{
  overflowY:"auto",
  overflowX:"hidden",
  height:"100%",
  background:"#000",
  border:"2px solid #5a5a5a",
},
stickMainContainerBatch:{
  overflowY:"auto",
  overflowX:"hidden",
  height:"100%",
  background:"#424242",
  border:"2px solid #5a5a5a",
},
clearanceQuestionBox:{
  boxShadow: "none",
borderRight:"3px solid #fff",
  overflowY: "auto",
  position: "relative",
},
tracksContainer:{
  // height:"calc(140% - 121px)",
  // background:"none",
  // borderLeft:"1px solid #ccc",
  // position: "absolute",
  // left:"0",
  height:"100%",
  boxShadow: "none",
  overflowY: "auto",
  width: "100%",
  "& .MuiTabs-scrollable button":{
    fontSize:"12px",
  },
  "& .MuiTypography-body1":{
    fontSize:"14px",
  },
  "& .statusContainer":{
    marginLeft:"auto",
    marginRight: "10px",
    "& .MuiCircularProgress-colorPrimary":{
      width: "20px !important",
      height: "20px!important",
      color: "white",
    },
    "& div":{
      border:"none",
      overflow: "hidden",
      textOverflow: "ellipsis"
    }
  },
  "& .usageContainer":{
    display:"block",
    fontSize:"12px",
    fontWeight:"normal",
    color:"#FAD200"
  }
},
accordianContainer:{
  borderBottom:"2px solid #fff",
  fontWeight:"300",
  fontSize:"13px",
  "& .MuiAccordionSummary-content":{
    alignItems:"center",
  },
  "& .metaContainer":{
    fontSize:"14px",
    "& label":{
      minWidth:"200px",
      color:"#e0e0e0",
      textTransform: "uppercase",
      fontWeight:"normal"
    },
    "& > div":{
      display:"flex",
      fontSize:"13px",
      color:"#fff",
      fontWeight:"bold",
      marginBottom: "5px",
    }
  },
},

indexNumber:{
  minWidth:"24px",
},
customErrorAlign:{
  textAlign:"left",
    paddingLeft:"23px",
},
appbarZindex:{
  zIndex:"999",
},
textAreaBLock:{
  width:"100%",
  "& .Mui-error":{
    marginLeft:"0 !important", 
  }
},

AutoSearchBox:{
  padding:"0px",
  "& .MuiAutocomplete-popupIndicator":{
    margin:"3px",
    padding:"0 !important",
  }, 
  "& .MuiAutocomplete-endAdornment":{
    width:"auto",
  },
  "& .MuiSvgIcon-fontSizeSmall":{
      fontSize: "1rem", 
  },    
    "& div:before": {
        outline: "none",
        border: "none !important",
        width: "100%",
    },
    "& .MuiInput-underline:after": {
        borderBottom: "none",
    },
    "& div": {
        width: "100%",
        borderRadius:"5px",
        padding:"0 !important",
        border:"rgba(255, 255, 255, 0.23)",
    },
    "& .MuiAutocomplete-endAdornment": {
      top: "calc(50% - 11px)",
      right: "3px",
      position:" absolute",
  },
  "& .MuiInputBase-adornedEnd input": {
    border:"1px solid rgba(255, 255, 255, 0.23)"
},
  "& .Mui-focused input": {
     border:"1px solid #46af22 !important"
},
    "& input": {
        width: "100%",
        padding:"10px !important",
         fontSize:"12px",
        fontWeight: "300",
        background:"#505050",
    },
},

AutoCompleteContainer:{
  "& .MuiAutocomplete-popper":{
    minWidth:"200px"
  }
},
tabContainer:{
  width: "100%",
    background: "#292929",
    borderRadius: "7px"
},
usageLabel:{
  display:"flex",
  padding:"15px",
  background:"#282828",
  alignItems:" center",
  "& .MuiInputLabel-animated":{
    whiteSpace: "nowrap",
    fontSize: "13px",
    fontWeight: "bold",
    color: "#fff",
    marginRight: "10px",
  }
},
trackUsageSelector:{
  background:"#343434",
  border:"1px solid #6B6A6A",
  width: "auto",
  minWidth: "200px",
},
trackTabsHeader:{
  background:"#242424",
  "& .MuiTabs-indicator":{
    backgroundColor:"#0C853E !important"
  },
  "& .MuiTabs-flexContainer":{
    justifyContent: "flex-start !important",
    "& button":{
      paddingLeft: "15px !important",
      paddingRight: "15px !important",
    }
  }
},

});


